/** Variante B do teste A/B: hero original + vídeo ao longo da página. */
import { createFileRoute } from "@tanstack/react-router";

import { FAQ, RoteiroAvaliacaoLP } from "@/components/roteiro/RoteiroAvaliacaoLP";


export const Route = createFileRoute("/roteiro-avaliacao-2")({
  head: () => ({
    meta: [
      { title: "Roteiro de Avaliação Musculoesquelética · aulas + e-book | FEO" },
      {
        name: "description",
        content:
          "Aulas em vídeo e e-book do Roteiro Prático de Avaliação Musculoesquelética, com certificado de 5h. Estruture sua avaliação clínica por R$37 (de R$97).",
      },
      { property: "og:title", content: "Roteiro de Avaliação Musculoesquelética · aulas + e-book | FEO" },
      {
        property: "og:description",
        content: "Aulas em vídeo + e-book com certificado de 5h para avaliar com método e segurança. Por R$37,00.",
      },
      { property: "og:url", content: "https://fisioemortopedia.com.br/roteiro-avaliacao-2" },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "Roteiro de Avaliação Musculoesquelética · aulas + e-book | FEO" },
      {
        name: "twitter:description",
        content: "Aulas em vídeo + e-book com certificado de 5h para avaliar com método e segurança. Por R$37,00.",
      },
    ],
    links: [{ rel: "canonical", href: "https://fisioemortopedia.com.br/roteiro-avaliacao-2" }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: FAQ.map((f) => ({
            "@type": "Question",
            name: f.q,
            acceptedAnswer: { "@type": "Answer", text: f.a },
          })),
        }),
      },
    ],
  }),
  component: RoteiroRouteMeio,
});

function RoteiroRouteMeio() {
  return <RoteiroAvaliacaoLP videoPlacement="meio" />;
}

